module.exports = __webpack_public_path__ + "static/img/14000508.720b5028.png";